import { render, staticRenderFns } from "./ChickFilATagButton.vue?vue&type=template&id=2494b7b6&scoped=true"
import script from "./ChickFilATagButton.vue?vue&type=script&lang=js"
export * from "./ChickFilATagButton.vue?vue&type=script&lang=js"
import style0 from "./ChickFilATagButton.vue?vue&type=style&index=0&id=2494b7b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../microservices/playlist/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2494b7b6",
  null
  
)

export default component.exports